import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Celsius from "../axes/Celsius";
import Day from "../axes/Day";

let WetTemperatureDay = {
    type: "line",
    label: "Wet Temperature",
    fill: false,
    lineTension: 0,
    colorPalette: 4,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Celsius,
    xAxis:Day
};

export default WetTemperatureDay;



// WEBPACK FOOTER //
// ./src/components/chart/channels/WetTemperatureDay.js